import { Injectable } from "@angular/core";
import { Headers, Http, RequestOptions, Response } from "@angular/http";
import { AuthenticationService } from "../authentication.service";
import { EnvironmentService } from "../index";
import { BehaviorSubject, Observable } from "rxjs";
import "rxjs/add/operator/map";
import "rxjs/add/operator/catch";
import {
  MonthlyCarPrice,
  AgreementLengths,
  AgreementKms,
} from "app/_models/used-cars/matrix-price";

@Injectable()
export class MatrixCalculatorService {
  private baseUrl: string =
    this.environmentService.getBaseURL() + "/api" + "/matrix/calculator";
  private usedCarsBaseUrl: string =
    this.environmentService.getBaseURL() +
    "/api" +
    "/matrix/products/used-cars/calculator";
  private prolongingsBaseUrl: string =
    this.environmentService.getBaseURL() +
    "/api" +
    "/matrix/products/prolongings/calculator";

  constructor(
    private http: Http,
    private authenticationService: AuthenticationService,
    private environmentService: EnvironmentService
  ) {}

  calculateAge(birthday: number) {
    var ageDifMs = Date.now() - birthday;
    var ageDate = new Date(ageDifMs);
    return Math.abs(ageDate.getUTCFullYear() - 1970);
  }

  getAgreementLengths({
    carId,
    firstreg,
    agreementStartDate,
    maxKms,
    maxLength,
    selectedKms,
    carKms,
    showPartialYears,
    untilDate,
    currentAgreementKms,
  }): Observable<AgreementLengths> {
    return this.http
      .post(
        `${this.baseUrl}/agreement-lengths/${carId}`,
        {
          carKms,
          selectedKms,
          showPartialYears,
          currentAgreementKms,
          untilTimestamp: untilDate.getTime(),
          maxKms:
            !maxKms || maxKms === "null" || maxKms === "" ? 200000 : maxKms,
          maxLength:
            !maxLength || maxLength === "null" || maxLength === ""
              ? 10
              : maxLength,
          agreementStartTimestamp: agreementStartDate.getTime(),
          carRegistrationTimestamp: firstreg.getTime(),
        },
        this.makeHeaders()
      )
      .map((response: Response) => response.json() as AgreementLengths);
  }

  getAgreementKms({
    carId,
    firstreg,
    agreementStartDate,
    maxKms,
    carKms,
    showPartialYears,
    untilDate,
    maxLength,
    currentAgreementKms,
  }): Observable<AgreementKms> {
    return this.http
      .get(
        `${this.baseUrl}/agreement-kms/${carId}?carKms=${carKms}&maxKms=${
          !maxKms || maxKms === "null" || maxKms === "" ? 200000 : maxKms
        }&untilTimestamp=${untilDate.getTime()}&agreementStartTimestamp=${agreementStartDate.getTime()}&carRegistrationTimestamp=${firstreg.getTime()}&showPartialYears=${showPartialYears}&currentAgreementKms=${currentAgreementKms}&maxLength=${maxLength}`,
        this.makeHeaders()
      )
      .map((response: Response) => response.json() as AgreementKms);
  }

  getUpsaleOptions(
    carId: string,
    kmPerYear: number,
    agreementStartDate: Date,
    firstreg: Date,
    currentAgreementKms: number
  ): Observable<{
    cheapest: MonthlyCarPrice;
    longest: MonthlyCarPrice;
    faster: MonthlyCarPrice;
  }> {
    return this.http
      .get(
        `${
          this.baseUrl
        }/upsale/${carId}/options?currentAgreementKms=${currentAgreementKms}&kmPerYear=${kmPerYear}&agreementStartTimestamp=${agreementStartDate.getTime()}&carRegistrationTimestamp=${firstreg.getTime()}`,
        this.makeHeaders()
      )
      .map((response: Response) => response.json());
  }

  getUsedCarMonthlyPrice(
    carId: string,
    agreementLength: string,
    kmPerYear: number,
    lastServiceDate: Date,
    firstreg: Date,
    currentAgreementKms: number
  ): Observable<MonthlyCarPrice> {
    return this.http
      .get(
        `${
          this.usedCarsBaseUrl
        }/monthly-price/${carId}?currentAgreementKms=${currentAgreementKms}&agreementLength=${agreementLength}&kmPerYear=${kmPerYear}&lastServiceTimestamp=${lastServiceDate.getTime()}&carRegistrationTimestamp=${firstreg.getTime()}`,
        this.makeHeaders()
      )
      .map((response: Response) => response.json() as MonthlyCarPrice);
  }

  getProlongingsMonthlyPrice(
    carId: string,
    agreementLength: string,
    kmPerYear: number,
    agreementExpirationDate: Date,
    firstreg: Date,
    currentAgreementKms: number
  ): Observable<MonthlyCarPrice> {
    return this.http
      .get(
        `${
          this.prolongingsBaseUrl
        }/monthly-price/${carId}?currentAgreementKms=${currentAgreementKms}&agreementLength=${agreementLength}&kmPerYear=${kmPerYear}&agreementExpirationTimestamp=${agreementExpirationDate.getTime()}&carRegistrationTimestamp=${firstreg.getTime()}`,
        this.makeHeaders()
      )
      .map((response: Response) => response.json() as MonthlyCarPrice);
  }

  private makeHeaders(): RequestOptions {
    let headers = new Headers();

    headers.append("Authorization", this.authenticationService.getToken());
    headers.append("Content-Type", "application/json ");
    headers.append("charset", "UTF-8 ");
    headers.append("Accept", "application/json ");

    let options = new RequestOptions({ headers: headers });
    return options;
  }
}



// WEBPACK FOOTER //
// ./src/app/_services/matrix/matrix-calculator.service.ts